module.exports = __webpack_public_path__ + "img/airbar_max_vape_1.014ec81f.png";